<template>
  <div class="flex-col h-100">

    <div class="flex-row">
      <span v-if="showBack"
        class="iconfont iconarrowleft-outline back-info"
        @click="goBack"></span>
      <label class="top-title"
        v-if="!isEdit">{{ $t('addRelationship') }}</label>
      <label class="top-title"
        v-if="isEdit">{{ $t('viewRelationship') }}</label>
    </div>
    <div class="flex-col list-info">
      <van-tabs type="card"
        v-model="order"
        style="height: 100%; overflow-y: auto; overflow-x: hidden"
        @click="changeTab">
        <van-tab :title="$t('search.orgRelationship')"
          style="padding-top: 20px;">
          <orgRelationship ref="orgRelationship"
            :url="fromUrl"></orgRelationship>
        </van-tab>
        <van-tab :title="$t('search.companyRelationship')"
          style="padding-top: 20px;">
          <companyRelationship ref="companyRelationship"
            :url="fromUrl"></companyRelationship>
        </van-tab>
      </van-tabs>
    </div>
  </div>
</template>

<script>  
import orgRelationship from "./AddRelationship/orgRelationship";
import companyRelationship from "./AddRelationship/companyRelationship";
let orgUrl = '';
export default {
  name: "AddRelationship",

  data () {
    return {
      fromUrl: '',
      showBack: false,
      order: 0,
      isEdit: false,
      curPageName: 'orgRelationship',
    };
  },
  components: {
    orgRelationship,
    companyRelationship
  },

  beforeRouteEnter (to, from, next) {
    orgUrl = from.path;
    console.log('beforeRouteEnter');
    next();
  },
  mounted () {
    if (this.$route.query.id || this.$route.query.orgData || this.$route.query.companyData || this.$route.query.relationshipId) {
      this.showBack = true;
    }
    if (this.$route.query.type == 'company') {
      this.showBack = true;
      this.order = 1;
    } else {
      this.order = 0;
    }
    // debugger;
    this.isEdit = this.$route.query.isEdit == 'true';
    this.fromUrl = orgUrl;
  },
  methods: {
    changeTab () {

    },
    goBack () {
      this.$router.go(-1);
    },
  },
};
</script>

<style lang='scss' scoped>
.back-info {
  padding-left: 1rem;
  font-size: 25px;
  text-align: center;
  align-items: center;
  display: flex;
  color: darkgray;
}
.list-info {
  height: calc(100% - 120px);
  padding: 10px 0 0 0;
}
/deep/ .van-tabs--card > .van-tabs__wrap {
  height: 36px;
}
/deep/ .van-tabs__nav {
  height: 32px;
}
/deep/ .van-tab {
  font-size: 14px;
}
/deep/ .van-tabs__content {
  height: calc(100% - 50px);
}
/deep/ .van-tabs__nav--card .van-tab.van-tab--active {
  background-color: #c52a1a;
  color: #ffffff;
}
/deep/ .van-tabs__nav--card .van-tab {
  color: #7d7d7d;
}
/deep/ .van-tabs__nav--card {
  border-color: #979797;
}
/deep/ .van-tab__pane {
  height: 100%;
}
/deep/ .van-tabs__nav--card .van-tab {
  border-right: 1px solid #c52a1a;
}
/deep/ .van-tabs__nav--card .van-tab:last-child {
  border-right: none;
}
</style>


// WEBPACK FOOTER //
// src/views/add/AddRelationship.vue